import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const defaultDuration = 4000

type Notification = {
	id: number
	text: string
	type: 'error' | 'success'
	duration?: number
}

export interface State {
	notifications: Notification[]
}

const initialState: State = {
	notifications: [],
}

export const notificationSlice = createSlice({
	name: 'notificaionSlice',
	initialState,
	reducers: {
		add: (state, action: PayloadAction<Notification>) => {
			const { duration, id } = action.payload

			state.notifications = [...state.notifications, action.payload]
			setTimeout(() => {
				state.notifications = state.notifications.filter((el) => el.id !== id)
			}, duration ?? defaultDuration)
		},
	},
})

export const { add } = notificationSlice.actions

export default notificationSlice.reducer
